import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ContextService,
  TokenService,
} from '@maximizer/core/shared/data-access';
import { OAuth2Service } from '@maximizer/oauth2/data-access';
import { Observable, map, of } from 'rxjs';

// The add-in has no core-web session, so the base getToken() endpoint does not
// exist here; missing tokens refresh through the Outlook OAuth2 flow instead.
@Injectable()
export class OutlookAiTokenService extends TokenService {
  constructor(
    http: HttpClient,
    private readonly contextService: ContextService,
    private readonly oauth2Service: OAuth2Service,
  ) {
    super(http, contextService);
  }

  override getToken(): Observable<string> {
    if (this.contextService.token) {
      return of(this.contextService.token);
    }

    return this.oauth2Service
      .refreshToken(undefined, true, 'iq-boost-401-retry')
      .pipe(map((token) => token?.access_token ?? ''));
  }
}
